import { featureToggles } from '@otto-ec/eprivacy-shared'

export const IS_ONETRUST_ENABLED_TOGGLE_KEY = 'cb_enable_onetrust'

export function isOneTrustEnabled(): boolean {
  return featureToggles(IS_ONETRUST_ENABLED_TOGGLE_KEY, true)
}
